module.exports = __webpack_public_path__ + "static/media/ico_report_action_o.fc2c5342.svg";